import { styled } from "@compiled/react";

import { UiHeadingModel } from "../../models";

type UiHeadingProps = {
    readonly model: UiHeadingModel;
};

const baseHeadingStyle = {
    fontWeight: 500,
    marginBlockEnd: "0.5rem",
    marginBlockStart: 0
};

const UiHeading = ({ model }: UiHeadingProps) => {
    const { text, headingLevel, appearance } = model.content;
    return (
        <Heading as={headingLevel} data-appearance={appearance}>
            {text}
        </Heading>
    );
};

export default UiHeading;

const Heading = styled.h1({
    [`&[data-appearance="h1"]`]: {
        "fontWeight": 500,
        "marginBlockEnd": "0.5rem",
        "marginBlockStart": 0,
        "fontSize": "2rem",
        "lineHeight": 1.25,
        "@media (min-width: 768px)": {
            "fontSize": "2.75rem",
            "font-size": "2.75rem",
            "lineHeight": 1.18181818,
            "line-height": 1.18181818
        },
        "@media (min-width: 992px)": {
            "fontSize": "3rem",
            "font-size": "3rem",
            "lineHeight": 1.25,
            "line-height": 1.25
        }
    },
    [`&[data-appearance="h2"]`]: {
        "fontWeight": 500,
        "marginBlockEnd": "0.5rem",
        "marginBlockStart": 0,
        "fontSize": "1.5rem",
        "lineHeight": 1.33333333,
        "@media (min-width: 768px)": {
            "fontSize": "2.25rem",
            "font-size": "2.25rem",
            "lineHeight": 1.33333333,
            "line-height": 1.33333333
        }
    },
    [`&[data-appearance="h3"]`]: {
        "fontWeight": 500,
        "marginBlockEnd": "0.5rem",
        "marginBlockStart": 0,
        "fontSize": "1.25rem",
        "lineHeight": 1.2,
        "@media (min-width: 768px)": {
            "fontSize": "1.5rem",
            "font-size": "1.5rem",
            "lineHeight": 1.33333333,
            "line-height": 1.33333333
        }
    },
    [`&[data-appearance="h4"]`]: {
        "fontWeight": 500,
        "marginBlockEnd": "0.5rem",
        "marginBlockStart": 0,
        "fontSize": "1rem",
        "lineHeight": 1.25,
        "@media (min-width: 768px)": {
            "fontSize": "1.25rem",
            "font-size": "1.25rem",
            "lineHeight": 1.2,
            "line-height": 1.2
        }
    },
    [`&[data-appearance="h5"]`]: {
        "fontWeight": 500,
        "font-weight": 500,
        "marginBlockEnd": "0.5rem",
        "margin-block-end": "0.5rem",
        "marginBlockStart": 0,
        "margin-block-start": 0,
        "fontSize": "1rem",
        "font-size": "1rem",
        "lineHeight": 1.25,
        "line-height": 1.25,
        "textTransform": "uppercase",
        "text-transform": "uppercase"
    },
    [`&[data-appearance="h6"]`]: {
        "fontSize": "1rem",
        "font-size": "1rem",
        "fontWeight": 500,
        "font-weight": 500,
        "lineHeight": 1.2,
        "line-height": 1.2,
        "marginBlockEnd": "0.5rem",
        "margin-block-end": "0.5rem",
        "marginBlockStart": 0,
        "margin-block-start": 0
    }
});
